import React from 'react';
import { StyledContainer, HeroBackground } from './HeroBackgroundContainer.styles.mjs';

const HeroBackgroundContainer = ({ bgImage }) => {
    return (React.createElement(StyledContainer, { fullWidth: true },
        React.createElement(HeroBackground, { bgImage: bgImage })));
};

export { HeroBackgroundContainer as default };
//# sourceMappingURL=HeroBackgroundContainer.mjs.map
